"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Collection of static functions to find the targeted tree node.
 */
exports.NavigateTree = {
    /**
     * If the given Element is given, focus on it and return it as a
     * HTMLElement, otherwise return null.
     *
     * @param element The Element to focus on.
     * @returns {HTMLElement} The element in focus.
     */
    focus: function (element) {
        element && element.setAttribute('tabIndex', '0');
        element && element.focus();
        return element;
    },
    /**
     * Calls functions on a given Element until a truthy result is returned.
     *
     * @param self The Element to pass to the functions.
     * @param funcs A collection of functions to call until one returns an
     *      Element.
     * @returns {Element} The element returned.
     */
    getNode: function (self) {
        var funcs = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            funcs[_i - 1] = arguments[_i];
        }
        for (var _a = 0, funcs_1 = funcs; _a < funcs_1.length; _a++) {
            var func = funcs_1[_a];
            var element = func && func(self);
            if (element) {
                if (element.getAttribute('role') === 'separator') {
                    return exports.NavigateTree.getNode.apply(exports.NavigateTree, [element].concat(funcs));
                }
                return element;
            }
        }
        return null;
    },
    /**
     * Returns the root node of the given Element if it exists in a tree.
     *
     * @param element The Element to find the root node of.
     * @returns {Element} The root node.
     */
    getRoot: function (element) {
        if (element.getAttribute('role') === 'tree') {
            return element;
        }
        else if (element.parentElement) {
            return exports.NavigateTree.getRoot(element.parentElement);
        }
        else {
            return null;
        }
    },
    /**
     * Returns the parent element of the given Element.
     *
     * @param element The Element to find the parent of.
     * @returns {Element} The parent.
     */
    getParent: function (element) {
        if (element.getAttribute('role') === 'tree') {
            return null;
        }
        var parent = element.parentElement;
        return (parent &&
            parent.getAttribute('role') !== 'tree' &&
            parent.parentElement);
    },
    /**
     * Returns the previous sibling of the given Element.
     *
     * @param element The Element to find the previous sibling of.
     * @returns {Element} The previous sibling.
     */
    getPreviousSibling: function (element) {
        return element.previousElementSibling;
    },
    /**
     * Returns the next sibling of the given Element.
     *
     * @param element The Element to find the next sibling of.
     * @returns {Element} The next sibling.
     */
    getNextSibling: function (element) {
        return element.nextElementSibling;
    },
    /**
     * Returns the first child of the given Element.
     *
     * @param element The Element to find the first child of.
     * @returns {Element} The first child.
     */
    getFirstChild: function (element) {
        var subtree = element.getAttribute('role') === 'tree'
            ? element
            : element.children.item(1);
        return subtree && subtree.firstElementChild;
    },
    /**
     * Returns the last child of the given Element.
     *
     * @param element The Element to find the last child of.
     * @returns {Element} The last child.
     */
    getLastChild: function (element) {
        // The last child will have no children itself.
        if (!element.childElementCount) {
            var treeChild = element;
            if (treeChild.getAttribute('role') === 'separator') {
                return exports.NavigateTree.getNode(element, exports.NavigateTree.getPreviousSiblingLastChild, exports.NavigateTree.getPreviousSibling);
            }
            // When we get to the end of the branch, we need to check that we
            // have the treeitem.
            while (treeChild.getAttribute('role') !== 'treeitem' &&
                treeChild.getAttribute('role') !== 'separator') {
                treeChild = treeChild.parentElement;
            }
            return treeChild;
        }
        else {
            return exports.NavigateTree.getLastChild(element.lastElementChild);
        }
    },
    /**
     * Returns the previous sibling's last child for the given Element.
     *
     * @param element The Element to find the previous sibling's last child of.
     * @returns {Element} The previous sibling's last child.
     */
    getPreviousSiblingLastChild: function (element) {
        var previousSibling = element.previousElementSibling;
        return previousSibling && exports.NavigateTree.getLastChild(previousSibling);
    },
    /**
     * Returns the parent's next sibling for the given Element.
     *
     * @param element The Element to find the parent's next sibling of.
     * @returns {Element} The parent's next sibling.
     */
    getParentNextSibling: function (element) {
        if (element.getAttribute('role') === 'tree') {
            return null;
        }
        var parent = element && element.parentElement;
        if (!parent || parent.getAttribute('role') === 'tree') {
            return null;
        }
        var parentNextSibling = parent && parent.nextElementSibling;
        // If the parent doesn't have a next sibling, keep going up the tree to
        // find ancestor next siblings.
        return parentNextSibling || exports.NavigateTree.getParentNextSibling(parent);
    },
    /**
     * Returns the first node with text matching the given substring.
     *
     * @param element The Element to start searching from.
     * @param searchText The substring to search for in the node.
     * @returns {Element} The node with the matching text.
     */
    getNextMatch: function (element, searchText) {
        if (!searchText) {
            return null;
        }
        var nextNode = exports.NavigateTree.getNode(element, exports.NavigateTree.getFirstChild, exports.NavigateTree.getNextSibling, exports.NavigateTree.getParentNextSibling);
        if (!nextNode) {
            return nextNode;
        }
        var elementText = nextNode.innerText || nextNode.textContent;
        if (elementText &&
            elementText.substring(0, searchText.length).toLowerCase() ===
                searchText.toLowerCase()) {
            return nextNode;
        }
        else {
            return exports.NavigateTree.getNextMatch(nextNode, searchText);
        }
    },
};
//# sourceMappingURL=utils.js.map